import { Button } from "antd";
function FaceBookTheme({card}) {
  console.log(card);

  return (
    <div className="flex p-2 md:py-4 justify-center bg-gray-200">
      <div className="relative max-w-[393px] h-full bg-black rounded-xl shadow-lg overflow-hidden font-poppins">
        <div>
          <img 
            src={card?.backgroundImage} 
            alt="Background" 
            className="w-full" 
          />
        </div>
        
        <div className="absolute top-[18rem] left-1/2 transform -translate-x-1/2 -translate-y-1/2">
          <img
            src={card?.profileImage}
            alt="Profile"
            className="w-24 h-24 rounded-full object-cover"
          />
        </div>
        
        <div className="text-center pt-[6rem]">
          <h2 className="text-3xl font-bold text-white break-all break-words">
            {card?.data?.headline}
          </h2>
          <p className="text-[#D0D0D0] px-10 py-3 break-all break-words">
            {card?.data?.subHeadline}
          </p>
          <div className="pt-[2rem] pb-[10rem] px-[6rem]">
            <Button
              className="w-full h-full bg-custom-gradient rounded py-2 hover:opacity-90 transition-opacity break-all break-words"
              type="primary"
              onClick={() => window.open(card?.data?.buttonLink || card?.data?.facebookURL, "_blank")}
            >
              {card?.data?.buttonText}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default FaceBookTheme;
